import React from "react";
import { useToggle } from "react-use";

import { Drawer } from "@mui/material";

import { Button } from "@/components/form/Button/Button";
import { scrollBarSxStyles } from "@/shared/styles";

import { SearchFilters } from "./SearchFilters";

export const MobileSearchFilters: React.FC = () => {
  const [isOpened, toggle] = useToggle(false);
  const closeDrawer = () => toggle(false);

  return (
    <div className="p-4 top-0 z-[1] bg-white">
      <Button
        size="large"
        variant="primary"
        onHoverVariant="gradient-flip"
        className="md:hidden"
        fullWidth
        onClick={() => toggle(true)}
      >
        Search options
      </Button>
      <Drawer
        open={isOpened}
        PaperProps={{ sx: scrollBarSxStyles }}
        slotProps={{ backdrop: { onClick: () => toggle(false) } }}
        ModalProps={{ onScroll: (e) => e.stopPropagation() }}
      >
        <div className="p-4 box-border mx-1">
          <SearchFilters closeDrawer={closeDrawer} />
        </div>
      </Drawer>
    </div>
  );
};
